import { CIMSModuleItem } from '../CIMSModule'
import { CIMSPageItem } from '../cimsPage'
import { CASPermission } from './instances/cas'
import {
  EditCASNotification,
  ViewCASNotification,
} from './instances/cas/notifications'
import {
  CreateCASQuickLink,
  EditCASQuickLink,
  RemoveRestoreCASQuickLink,
  ViewCASQuickLink,
} from './instances/cas/quickLinks'
import {
  CreateCASRoutingGroup,
  EditCASRoutingGroup,
  RemoveRestoreCASRoutingGroup,
  ViewCASRoutingGroup,
} from './instances/cas/routingGroups'
import {
  CreateCASSubtype,
  EditCASSubtype,
  RemoveRestoreCASSubtype,
  ViewCASSubtype,
} from './instances/cas/subtypes'
import {
  CommentOnConstructionAdminSubmittal,
  CreateConstructionAdminSubmittal,
  CreateCASPacket,
  EditConstructionAdminSubmittal,
  EditNumberNameConstructionAdminSubmittal,
  GiveDispositionConstructionAdminSubmittal,
  GroupReviewConstructionAdminSubmittal,
  RemoveRestoreConstructionAdminSubmittal,
  RevertConstructionAdminSubmittal,
  ReviewAllConstructionAdminSubmittal,
  ReviseConstructionAdminSubmittal,
  RouteConstructionAdminSubmittal,
  UnlockConstructionAdminSubmittal,
  ViewConstructionAdminSubmittal,
} from './instances/cas/tracker'
import {
  CreateCASType,
  ViewCASType,
  EditCASType,
  RemoveRestoreCASType,
} from './instances/cas/types'
import { DSPermission } from './instances/ds'
import {
  EditDesignSubmittalAction,
  RemoveRestoreDesignSubmittalAction,
  ViewDesignSubmittalAction,
  CreateDesignSubmittalAction,
} from './instances/ds/actions'
import {
  CreateDesignSubmittalDiscipline,
  EditDesignSubmittalDiscipline,
  RemoveRestoreDesignSubmittalDiscipline,
  ViewDesignSubmittalDiscipline,
} from './instances/ds/disciplines'
import {
  CommentOnDesignSubmittal,
  CreateDesignSubmittal,
  EditDesignSubmittal,
  EditNumberNameDesignSubmittal,
  GiveDispositionDesignSubmittal,
  RemoveRestoreDesignSubmittal,
  RevertDesignSubmittal,
  ReviewAllDesignSubmittal,
  RouteDesignSubmittal,
  UnlockDesignSubmittal,
  ViewDesignSubmittal,
} from './instances/ds/log'
import {
  EditDSNotification,
  ViewDSNotification,
} from './instances/ds/notifications'
import {
  CreateDesignSubmittalOrganization,
  EditDesignSubmittalOrganization,
  RemoveRestoreDesignSubmittalOrganization,
  ViewDesignSubmittalOrganization,
} from './instances/ds/orgs'
import {
  CreateDesignSubmittalQuickLink,
  EditDesignSubmittalQuickLink,
  RemoveRestoreDesignSubmittalQuickLink,
  ViewDesignSubmittalQuickLink,
} from './instances/ds/quickLinks'
import {
  CreateDesignSubmittalType,
  EditDesignSubmittalType,
  RemoveRestoreDesignSubmittalType,
  ViewDesignSubmittalType,
} from './instances/ds/types'
import { ImportExportPermission } from './instances/importsExports'
import { CreateBatchReportRequest } from './instances/importsExports/batchReports'
import { ImportCSV, ExportCSV } from './instances/importsExports/csv'
import {
  EditPDFDesignLayer,
  ViewPDFDesignLayer,
} from './instances/importsExports/pdfDesignLayers'
import {
  EditFilename,
  ViewFilename,
} from './instances/importsExports/pdfFilenames'
import { CreatePhotoExportRequest } from './instances/importsExports/photos'
import { CreateReport } from './instances/importsExports/singleReports'
import { ConcretePermission } from './instances/concrete'
import {
  CreateConcretePacket,
  EditAssociatedDocumentChecklistItem,
  EditConcreteBreakData,
  RemoveConcretePacketFile,
  UploadConcretePacketFile,
  ViewConcretePacketFile,
  ViewConcreteTestSet,
} from './instances/concrete/cts'
import {
  CreateDocumentChecklistItem,
  EditDocumentChecklistItem,
  RemoveDocumentChecklistItem,
  ViewDocumentChecklistItem,
} from './instances/concrete/documentCheckList'
import {
  EditConcreteNotification,
  ViewConcreteNotification,
} from './instances/concrete/notifications'
import {
  CreateLabTech,
  CreateTestingLab,
  EditAllTestingLab,
  EditLabTech,
  EditLimitedTestingLab,
  RemoveLabTech,
  RemoveTestingLab,
  ViewLabTech,
  ViewTestingLab,
} from './instances/concrete/testingLabs'
import { PayItemsPermission } from './instances/payItems'
import { FDCPermission } from './instances/fdc'
import {
  CreateFDCApprovalGroup,
  EditFDCApprovalGroup,
  RemoveRestoreFDCApprovalGroup,
  ViewFDCApprovalGroup,
} from './instances/fdc/approvalGroups'
import {
  CreateFDCConcurrenceGroup,
  CreateFDCConcurrenceLevel,
  EditFDCConcurrenceGroup,
  EditFDCConcurrenceLevel,
  RemoveRestoreFDCConcurrenceGroup,
  RemoveRestoreFDCConcurrenceLevel,
  ViewFDCConcurrenceGroup,
  ViewFDCConcurrenceLevel,
} from './instances/fdc/concurrences'
import {
  CreateFDCDiscipline,
  EditFDCDiscipline,
  RemoveRestoreFDCDiscipline,
  ViewFDCDiscipline,
} from './instances/fdc/disciplines'
import {
  EditFDCNotification,
  ViewFDCNotification,
} from './instances/fdc/notifications'
import {
  CreateFDCQuickLink,
  EditFDCQuickLink,
  RemoveRestoreFDCQuickLink,
  ViewFDCQuickLink,
} from './instances/fdc/quickLinks'
import {
  CommentOnFieldDesignChange,
  CreateFieldDesignChange,
  EditFieldDesignChange,
  EditFieldDesignChangeResolution,
  RevertFieldDesignChange,
  RemoveRestoreFieldDesignChange,
  UnlockFieldDesignChange,
  ViewFieldDesignChange,
} from './instances/fdc/tracker'
import { AdminPermission } from './instances/admin'
import {
  CreateCustomField,
  EditCustomField,
  RemoveRestoreCustomField,
  ViewCustomField,
} from './instances/admin/customFields'
import {
  CreateNonUserEmail,
  EditNonUserEmail,
  RemoveNonUserEmail,
  ViewNonUserEmail,
} from './instances/admin/nonUserEmails'
import {
  CreateRole,
  EditRole,
  RemoveRestoreRole,
  ViewRole,
} from './instances/admin/roles'
import {
  EditProjectSettings,
  EditSharePointSettings,
  EditWorkflowSettings,
  ViewProjectSettings,
} from './instances/admin/settings'
import {
  EditUserPermission,
  EditUserRole,
  ViewUser,
} from './instances/admin/users'
import {
  DeveloperPermission,
  AssociateProjectWithCIMS,
  CreateAPIKey,
  RemoveAPIKey,
  ViewAPIKey,
  SyncUsers,
  EditRFIResponse,
  RefreshRedisCache,
} from './instances/dev'
import { NamedComplexEnum } from '../../utils/complexEnum/NamedComplexEnum'
import {
  BasicPermissionItem as Basic,
  DeveloperPermissionItem as Dev,
} from './PermissionItem'
import { CIMSModuleItem as ModuleItem } from '../CIMSModule/CIMSModuleItem'
import { IFIPermission } from './instances/ifi'
import {
  EditIFINotification,
  ViewIFINotification,
} from './instances/ifi/notifications'
import {
  CommentOnIdentifiedFieldIssue,
  EditIdentifiedFieldIssue,
  RevertIdentifiedFieldIssue,
  ReviewIdentifiedFieldIssue,
  ViewIdentifiedFieldIssue,
} from './instances/ifi/tracker'
import {
  CreateIssueDispositionType,
  EditIssueDispositionType,
  RemoveRestoreIssueDispositionType,
  ViewIssueDispositionType,
} from './instances/issues/dispositionTypes'
import {
  EditIssueNotification,
  ViewIssueNotification,
} from './instances/issues/notifications'
import {
  CreateIssueQuickLink,
  EditIssueQuickLink,
  RemoveRestoreIssueQuickLink,
  ViewIssueQuickLink,
} from './instances/issues/quicklinks'
import {
  CreateIssue,
  EditIssue,
  RemoveRestoreIssue,
  ViewIssue,
  EditIssueResponse,
  CommentOnIssue,
  RevertIssue,
  UnlockIssue,
  RespondToIssue,
  GiveIssueDisposition,
  CloseIssue,
} from './instances/issues/tracker'
import {
  CreateIssueType,
  EditIssueType,
  RemoveRestoreIssueType,
  ViewIssueType,
} from './instances/issues/types'
import { IssuesPermission } from './instances/issues'
import {
  CreatePayItemConnection,
  CreatePayItemConnectionGroup,
  EditPayItemConnection,
  EditPayItemConnectionGroup,
  RemoveRestorePayItemConnection,
  RemoveRestorePayItemConnectionGroup,
  SyncPayItemConnection,
  ViewPayItemConnection,
  ViewPayItemConnectionGroup,
} from './instances/payItems/manage'
import {
  EditPayItemSummary,
  ViewPayItemSummary,
} from './instances/payItems/summary'
import { RFIPermission } from './instances/rfi'
import {
  CommentOnRequestForInformation,
  CreateRequestForInformation,
  EditRequestForInformation,
  RespondAllRFIResponseDisciplines,
  RemoveRestoreRequestForInformation,
  RevertRequestForInformation,
  UnlockRequestForInformation,
  ViewRequestForInformation,
} from './instances/rfi/tracker'
import {
  CreateRFIOrganization,
  EditRFIOrganization,
  RemoveRestoreRFIOrganization,
  ViewRFIOrganization,
} from './instances/rfi/organizations'
import {
  CreateRFIResponseDiscipline,
  ViewRFIResponseDiscipline,
  EditRFIResponseDiscipline,
  RemoveRestoreRFIResponseDiscipline,
} from './instances/rfi/responseDisciplines'
import {
  CreateRFIQuickLink,
  ViewRFIQuickLink,
  EditRFIQuickLink,
  RemoveRestoreRFIQuickLink,
} from './instances/rfi/quickLinks'
import {
  EditRFINotification,
  ViewRFINotification,
} from './instances/rfi/notifications'
import {
  CreateCASDispositionType,
  EditCASDispositionType,
  RemoveRestoreCASDispositionType,
  ViewCASDispositionType,
} from './instances/cas/dispositionTypes'
import { MaterialsPermissionItem } from './instances/materials'
import {
  CreateAsphaltMixDesign,
  EditAsphaltMixDesign,
  ViewAsphaltMixDesign,
} from './instances/materials/asphaltMixDesigns'
import {
  CreateConcreteMixDesign,
  EditConcreteMixDesign,
  ViewConcreteMixDesign,
} from './instances/materials/concreteMixDesign'
import {
  CreateLIMSAsphaltMixDesignTarget,
  EditLIMSAsphaltMixDesignTarget,
  RemoveRestoreLIMSAsphaltMixDesignTarget,
  ViewLIMSAsphaltMixDesignTarget,
} from './instances/materials/limsAsphaltMixDesignTargets'
import {
  CreateEngineeringJudgement,
  EditEngineeringJudgement,
  RemoveRestoreEngineeringJudgement,
  RevertEngineeringJudgement,
  ViewEngineeringJudgement,
} from './instances/ej/log'
import {
  EditEJNotification,
  ViewEJNotification,
} from './instances/ej/notifications'
import {
  CreateEJQuickLink,
  ViewEJQuickLink,
  EditEJQuickLink,
  RemoveRestoreEJQuickLink,
} from './instances/ej/quicklinks'
import {
  CreateEJType,
  ViewEJType,
  EditEJType,
  RemoveRestoreEJType,
} from './instances/ej/types'
import { EJPermission } from './instances/ej'

export type DeveloperPermissionItem = DeveloperPermission
export type PermissionItem =
  | DeveloperPermission
  | AdminPermission
  | CASPermission
  | DSPermission
  | EJPermission
  | ImportExportPermission
  | ConcretePermission
  | PayItemsPermission
  | FDCPermission
  | IFIPermission
  | IssuesPermission
  | RFIPermission
  | MaterialsPermissionItem
export type BasicPermissionItem = Exclude<
  PermissionItem,
  DeveloperPermissionItem
>

type Name = PermissionItem['name']
type ID = PermissionItem['id']

class PermissionEnum extends NamedComplexEnum<
  'Permission',
  PermissionItem,
  Name,
  ID
> {
  readonly typename = 'Permission'
  isDev(item: unknown): item is DeveloperPermissionItem {
    return item instanceof Dev
  }
  isBasic(item: unknown): item is BasicPermissionItem {
    return item instanceof Basic
  }
  /**
   * attempts to return a {@link BasicPermissionItem} for the supplied id
   */
  getBasic(id: string) {
    return this.basics.find((basic) => basic.id === id)
  }
  /**
   * returns a {@link BasicPermissionItem} for the supplied id or fails
   */
  getBasicOrFail(id: string) {
    return this.orFail(this.getBasic(id), id)
  }
  /**
   * attempts to return a {@link DeveloperPermissionItem} for the supplied id
   */
  getDeveloper(id: string) {
    return this.developers.find((dev) => dev.id === id)
  }
  /**
   * returns a {@link DeveloperPermissionItem} for the supplied id or fails
   */
  getDeveloperOrFail(id: string) {
    return this.orFail(this.getDeveloper(id), id)
  }
  /**
   * all basic permissions
   */
  get basics() {
    return this.reduce(...this.basic())
  }
  /**
   * all developer permissions
   */
  get developers() {
    return this.reduce((items, item) => {
      if (item instanceof Dev) items.push(item)
      return items
    }, Array<DeveloperPermissionItem>())
  }
  /**
   * reduces all basic permissions into a map, grouping them by the
   * {@link CIMSModuleItem} of their page, and then their {@link CIMSPageItem}
   */
  get moduleToPageToBasics() {
    return this.reduce((map, permission) => {
      if (permission instanceof Dev) return map
      const byPage =
        map.get(permission.page.module) ??
        new Map<CIMSPageItem, BasicPermissionItem[]>()
      const permissions = byPage.get(permission.page) ?? []
      permissions.push(permission)
      byPage.set(permission.page, permissions)
      return map.set(permission.page.module, byPage)
    }, new Map<CIMSModuleItem, Map<CIMSPageItem, BasicPermissionItem[]>>())
  }
  /**
   * reduces all basic permissions into a map, grouping them by their {@link CIMSPageItem}
   */
  get pageToBasics() {
    return this.reduce((map, permission) => {
      if (permission instanceof Dev) return map
      const permissions = map.get(permission.page) ?? []
      permissions.push(permission)
      return map.set(permission.page, permissions)
    }, new Map<CIMSPageItem, BasicPermissionItem[]>())
  }
  findByModuleOrPage(item: CIMSModuleItem | CIMSPageItem) {
    if (item instanceof ModuleItem) return this.findByModule(item)
    return this.findByPage(item)
  }
  /**
   * gathers all basic permissions of a specific {@link crud} type
   *
   * @param crud
   */
  findByCRUD(crud: PermissionItem['crud']): BasicPermissionItem[]
  /**
   * gathers all permissions of a specific {@link crud} type
   *
   * @param options
   */
  findByCRUD(
    options: Required<Pick<PermissionItem, 'crud'>> & { dev: true }
  ): PermissionItem[]
  findByCRUD(
    arg:
      | PermissionItem['crud']
      | (Required<Pick<PermissionItem, 'crud'>> & { dev: true })
  ) {
    const crud = typeof arg === 'string' ? arg : arg?.crud
    const filter = (e: PermissionItem) => e.crud === crud
    if (typeof arg === 'string') return this.basics.filter(filter)
    return this.filter(filter)
  }
  /**
   * gathers all basic permissions for the supplied page
   *
   * @param page {@link CIMSPageItem}
   */
  findByPage(page: CIMSPageItem) {
    return this.reduce(...this.basic()).filter(
      ({ page: { id } }) => id === page.id
    )
  }
  /**
   * gathers all basic permissions for the supplied module
   *
   * @param module {@link CIMSModuleItem}
   */
  findByModule(module: CIMSModuleItem) {
    return this.reduce(...this.basic()).filter(
      ({ page }) => page.module.id === module.id
    )
  }
  private basic() {
    return [
      (items: BasicPermissionItem[], item: PermissionItem) => {
        if (item instanceof Basic) items.push(item)
        return items
      },
      Array<BasicPermissionItem>(),
    ] as const
  }
  readonly AssociateProjectWithCIMS = AssociateProjectWithCIMS
  readonly CreateAPIKey = CreateAPIKey
  readonly RemoveAPIKey = RemoveAPIKey
  readonly ViewAPIKey = ViewAPIKey
  readonly CreatePayItemConnection = CreatePayItemConnection
  readonly CreatePayItemConnectionGroup = CreatePayItemConnectionGroup
  readonly EditPayItemConnection = EditPayItemConnection
  readonly EditPayItemConnectionGroup = EditPayItemConnectionGroup
  readonly EditPayItemSummary = EditPayItemSummary
  readonly RemoveRestorePayItemConnection = RemoveRestorePayItemConnection
  readonly RemoveRestorePayItemConnectionGroup =
    RemoveRestorePayItemConnectionGroup
  readonly SyncPayItemConnection = SyncPayItemConnection
  readonly ViewPayItemConnection = ViewPayItemConnection
  readonly ViewPayItemConnectionGroup = ViewPayItemConnectionGroup
  readonly ViewPayItemSummary = ViewPayItemSummary
  readonly EditCASNotification = EditCASNotification
  readonly ViewCASNotification = ViewCASNotification
  readonly CreateCASQuickLink = CreateCASQuickLink
  readonly EditCASQuickLink = EditCASQuickLink
  readonly RemoveRestoreCASQuickLink = RemoveRestoreCASQuickLink
  readonly ViewCASQuickLink = ViewCASQuickLink
  readonly CreateCASRoutingGroup = CreateCASRoutingGroup
  readonly EditCASRoutingGroup = EditCASRoutingGroup
  readonly RemoveRestoreCASRoutingGroup = RemoveRestoreCASRoutingGroup
  readonly ViewCASRoutingGroup = ViewCASRoutingGroup
  readonly CreateCASSubtype = CreateCASSubtype
  readonly EditCASSubtype = EditCASSubtype
  readonly RemoveRestoreCASSubtype = RemoveRestoreCASSubtype
  readonly ViewCASSubtype = ViewCASSubtype
  readonly CommentOnConstructionAdminSubmittal =
    CommentOnConstructionAdminSubmittal
  readonly CreateConstructionAdminSubmittal = CreateConstructionAdminSubmittal
  readonly CreateCASPacket = CreateCASPacket
  readonly EditConstructionAdminSubmittal = EditConstructionAdminSubmittal
  readonly EditNumberNameConstructionAdminSubmittal =
    EditNumberNameConstructionAdminSubmittal
  readonly GiveDispositionConstructionAdminSubmittal =
    GiveDispositionConstructionAdminSubmittal
  readonly GroupReviewConstructionAdminSubmittal =
    GroupReviewConstructionAdminSubmittal
  readonly RemoveRestoreConstructionAdminSubmittal =
    RemoveRestoreConstructionAdminSubmittal
  readonly RevertConstructionAdminSubmittal = RevertConstructionAdminSubmittal
  readonly ReviewAllConstructionAdminSubmittal =
    ReviewAllConstructionAdminSubmittal
  readonly ReviseConstructionAdminSubmittal = ReviseConstructionAdminSubmittal
  readonly RouteConstructionAdminSubmittal = RouteConstructionAdminSubmittal
  readonly UnlockConstructionAdminSubmittal = UnlockConstructionAdminSubmittal
  readonly ViewConstructionAdminSubmittal = ViewConstructionAdminSubmittal
  readonly CreateCASType = CreateCASType
  readonly ViewCASType = ViewCASType
  readonly EditCASType = EditCASType
  readonly RemoveRestoreCASType = RemoveRestoreCASType
  readonly EditDesignSubmittalAction = EditDesignSubmittalAction
  readonly RemoveRestoreDesignSubmittalAction =
    RemoveRestoreDesignSubmittalAction
  readonly ViewDesignSubmittalAction = ViewDesignSubmittalAction
  readonly CreateDesignSubmittalAction = CreateDesignSubmittalAction
  readonly CreateDesignSubmittalDiscipline = CreateDesignSubmittalDiscipline
  readonly EditDesignSubmittalDiscipline = EditDesignSubmittalDiscipline
  readonly ViewDesignSubmittalDiscipline = ViewDesignSubmittalDiscipline
  readonly RemoveRestoreDesignSubmittalDiscipline =
    RemoveRestoreDesignSubmittalDiscipline
  readonly CommentOnDesignSubmittal = CommentOnDesignSubmittal
  readonly CreateDesignSubmittal = CreateDesignSubmittal
  readonly EditDesignSubmittal = EditDesignSubmittal
  readonly EditNumberNameDesignSubmittal = EditNumberNameDesignSubmittal
  readonly GiveDispositionDesignSubmittal = GiveDispositionDesignSubmittal
  readonly RemoveRestoreDesignSubmittal = RemoveRestoreDesignSubmittal
  readonly RevertDesignSubmittal = RevertDesignSubmittal
  readonly ReviewAllDesignSubmittal = ReviewAllDesignSubmittal
  readonly RouteDesignSubmittal = RouteDesignSubmittal
  readonly UnlockDesignSubmittal = UnlockDesignSubmittal
  readonly ViewDesignSubmittal = ViewDesignSubmittal
  readonly EditDSNotification = EditDSNotification
  readonly ViewDSNotification = ViewDSNotification
  readonly CreateDesignSubmittalOrganization = CreateDesignSubmittalOrganization
  readonly EditDesignSubmittalOrganization = EditDesignSubmittalOrganization
  readonly RemoveRestoreDesignSubmittalOrganization =
    RemoveRestoreDesignSubmittalOrganization
  readonly ViewDesignSubmittalOrganization = ViewDesignSubmittalOrganization
  readonly CreateDesignSubmittalQuickLink = CreateDesignSubmittalQuickLink
  readonly EditDesignSubmittalQuickLink = EditDesignSubmittalQuickLink
  readonly RemoveRestoreDesignSubmittalQuickLink =
    RemoveRestoreDesignSubmittalQuickLink
  readonly ViewDesignSubmittalQuickLink = ViewDesignSubmittalQuickLink
  readonly CreateDesignSubmittalType = CreateDesignSubmittalType
  readonly EditDesignSubmittalType = EditDesignSubmittalType
  readonly RemoveRestoreDesignSubmittalType = RemoveRestoreDesignSubmittalType
  readonly ViewDesignSubmittalType = ViewDesignSubmittalType
  readonly ImportCSV = ImportCSV
  readonly ExportCSV = ExportCSV
  readonly CreateBatchReportRequest = CreateBatchReportRequest
  readonly EditPDFDesignLayer = EditPDFDesignLayer
  readonly ViewPDFDesignLayer = ViewPDFDesignLayer
  readonly EditFilename = EditFilename
  readonly ViewFilename = ViewFilename
  readonly CreatePhotoExportRequest = CreatePhotoExportRequest
  readonly CreateReport = CreateReport
  readonly CreateConcretePacket = CreateConcretePacket
  readonly EditAssociatedDocumentChecklistItem =
    EditAssociatedDocumentChecklistItem
  readonly EditConcreteBreakData = EditConcreteBreakData
  readonly RemoveConcretePacketFile = RemoveConcretePacketFile
  readonly UploadConcretePacketFile = UploadConcretePacketFile
  readonly ViewConcretePacketFile = ViewConcretePacketFile
  readonly ViewConcreteTestSet = ViewConcreteTestSet
  readonly CreateDocumentChecklistItem = CreateDocumentChecklistItem
  readonly EditDocumentChecklistItem = EditDocumentChecklistItem
  readonly RemoveDocumentChecklistItem = RemoveDocumentChecklistItem
  readonly ViewDocumentChecklistItem = ViewDocumentChecklistItem
  readonly EditConcreteNotification = EditConcreteNotification
  readonly ViewConcreteNotification = ViewConcreteNotification
  readonly CreateLabTech = CreateLabTech
  readonly CreateTestingLab = CreateTestingLab
  readonly EditAllTestingLab = EditAllTestingLab
  readonly EditLabTech = EditLabTech
  readonly EditLimitedTestingLab = EditLimitedTestingLab
  readonly RemoveLabTech = RemoveLabTech
  readonly RemoveTestingLab = RemoveTestingLab
  readonly ViewLabTech = ViewLabTech
  readonly ViewTestingLab = ViewTestingLab
  readonly CreateFDCApprovalGroup = CreateFDCApprovalGroup
  readonly EditFDCApprovalGroup = EditFDCApprovalGroup
  readonly RemoveRestoreFDCApprovalGroup = RemoveRestoreFDCApprovalGroup
  readonly ViewFDCApprovalGroup = ViewFDCApprovalGroup
  readonly CreateFDCConcurrenceGroup = CreateFDCConcurrenceGroup
  readonly CreateFDCConcurrenceLevel = CreateFDCConcurrenceLevel
  readonly EditFDCConcurrenceGroup = EditFDCConcurrenceGroup
  readonly EditFDCConcurrenceLevel = EditFDCConcurrenceLevel
  readonly RemoveRestoreFDCConcurrenceGroup = RemoveRestoreFDCConcurrenceGroup
  readonly RemoveRestoreFDCConcurrenceLevel = RemoveRestoreFDCConcurrenceLevel
  readonly ViewFDCConcurrenceGroup = ViewFDCConcurrenceGroup
  readonly ViewFDCConcurrenceLevel = ViewFDCConcurrenceLevel
  readonly CreateFDCDiscipline = CreateFDCDiscipline
  readonly EditFDCDiscipline = EditFDCDiscipline
  readonly RemoveRestoreFDCDiscipline = RemoveRestoreFDCDiscipline
  readonly ViewFDCDiscipline = ViewFDCDiscipline
  readonly EditFDCNotification = EditFDCNotification
  readonly ViewFDCNotification = ViewFDCNotification
  readonly CreateFDCQuickLink = CreateFDCQuickLink
  readonly EditFDCQuickLink = EditFDCQuickLink
  readonly RemoveRestoreFDCQuickLink = RemoveRestoreFDCQuickLink
  readonly ViewFDCQuickLink = ViewFDCQuickLink
  readonly CommentOnFieldDesignChange = CommentOnFieldDesignChange
  readonly CreateFieldDesignChange = CreateFieldDesignChange
  readonly EditFieldDesignChange = EditFieldDesignChange
  readonly EditFieldDesignChangeResolution = EditFieldDesignChangeResolution
  readonly RevertFieldDesignChange = RevertFieldDesignChange
  readonly RemoveRestoreFieldDesignChange = RemoveRestoreFieldDesignChange
  readonly UnlockFieldDesignChange = UnlockFieldDesignChange
  readonly ViewFieldDesignChange = ViewFieldDesignChange
  readonly CreateCustomField = CreateCustomField
  readonly EditCustomField = EditCustomField
  readonly RemoveRestoreCustomField = RemoveRestoreCustomField
  readonly ViewCustomField = ViewCustomField
  readonly CreateNonUserEmail = CreateNonUserEmail
  readonly EditNonUserEmail = EditNonUserEmail
  readonly RemoveNonUserEmail = RemoveNonUserEmail
  readonly ViewNonUserEmail = ViewNonUserEmail
  readonly CreateRole = CreateRole
  readonly EditRole = EditRole
  readonly RemoveRestoreRole = RemoveRestoreRole
  readonly ViewRole = ViewRole
  readonly EditProjectSettings = EditProjectSettings
  readonly EditSharePointSettings = EditSharePointSettings
  readonly EditWorkflowSettings = EditWorkflowSettings
  readonly ViewProjectSettings = ViewProjectSettings
  readonly EditUserPermission = EditUserPermission
  readonly EditUserRole = EditUserRole
  readonly ViewUser = ViewUser
  readonly ViewIdentifiedFieldIssue = ViewIdentifiedFieldIssue
  readonly EditIdentifiedFieldIssue = EditIdentifiedFieldIssue
  readonly ReviewIdentifiedFieldIssue = ReviewIdentifiedFieldIssue
  readonly RevertIdentifiedFieldIssue = RevertIdentifiedFieldIssue
  readonly CommentOnIdentifiedFieldIssue = CommentOnIdentifiedFieldIssue
  readonly EditIFINotification = EditIFINotification
  readonly ViewIFINotification = ViewIFINotification
  readonly CreateIssueType = CreateIssueType
  readonly EditIssueType = EditIssueType
  readonly RemoveRestoreIssueType = RemoveRestoreIssueType
  readonly ViewIssueType = ViewIssueType
  readonly CreateIssue = CreateIssue
  readonly EditIssue = EditIssue
  readonly RemoveRestoreIssue = RemoveRestoreIssue
  readonly ViewIssue = ViewIssue
  readonly EditIssueResponse = EditIssueResponse
  readonly CommentOnIssue = CommentOnIssue
  readonly RevertIssue = RevertIssue
  readonly UnlockIssue = UnlockIssue
  readonly RespondToIssue = RespondToIssue
  readonly GiveIssueDisposition = GiveIssueDisposition
  readonly CloseIssue = CloseIssue
  readonly CreateIssueQuickLink = CreateIssueQuickLink
  readonly EditIssueQuickLink = EditIssueQuickLink
  readonly RemoveRestoreIssueQuickLink = RemoveRestoreIssueQuickLink
  readonly ViewIssueQuickLink = ViewIssueQuickLink
  readonly EditIssueNotification = EditIssueNotification
  readonly ViewIssueNotification = ViewIssueNotification
  readonly CreateIssueDispositionType = CreateIssueDispositionType
  readonly EditIssueDispositionType = EditIssueDispositionType
  readonly RemoveRestoreIssueDispositionType = RemoveRestoreIssueDispositionType
  readonly ViewIssueDispositionType = ViewIssueDispositionType
  readonly CreateRequestForInformation = CreateRequestForInformation
  readonly ViewRequestForInformation = ViewRequestForInformation
  readonly EditRequestForInformation = EditRequestForInformation
  readonly RemoveRestoreRequestForInformation =
    RemoveRestoreRequestForInformation
  readonly CommentOnRequestForInformation = CommentOnRequestForInformation
  readonly RespondAllRFIResponseDisciplines = RespondAllRFIResponseDisciplines
  readonly RevertRequestForInformation = RevertRequestForInformation
  readonly UnlockRequestForInformation = UnlockRequestForInformation
  readonly CreateRFIOrganization = CreateRFIOrganization
  readonly ViewRFIOrganization = ViewRFIOrganization
  readonly EditRFIOrganization = EditRFIOrganization
  readonly RemoveRestoreRFIOrganization = RemoveRestoreRFIOrganization
  readonly CreateRFIResponseDiscipline = CreateRFIResponseDiscipline
  readonly ViewRFIResponseDiscipline = ViewRFIResponseDiscipline
  readonly EditRFIResponseDiscipline = EditRFIResponseDiscipline
  readonly RemoveRestoreRFIResponseDiscipline =
    RemoveRestoreRFIResponseDiscipline
  readonly CreateRFIQuickLink = CreateRFIQuickLink
  readonly ViewRFIQuickLink = ViewRFIQuickLink
  readonly EditRFIQuickLink = EditRFIQuickLink
  readonly RemoveRestoreRFIQuickLink = RemoveRestoreRFIQuickLink
  readonly ViewRFINotification = ViewRFINotification
  readonly EditRFINotification = EditRFINotification
  readonly CreateCASDispositionType = CreateCASDispositionType
  readonly EditCASDispositionType = EditCASDispositionType
  readonly RemoveRestoreCASDispositionType = RemoveRestoreCASDispositionType
  readonly ViewCASDispositionType = ViewCASDispositionType
  readonly CreateAsphaltMixDesign = CreateAsphaltMixDesign
  readonly EditAsphaltMixDesign = EditAsphaltMixDesign
  readonly ViewAsphaltMixDesign = ViewAsphaltMixDesign
  readonly CreateConcreteMixDesign = CreateConcreteMixDesign
  readonly EditConcreteMixDesign = EditConcreteMixDesign
  readonly ViewConcreteMixDesign = ViewConcreteMixDesign
  readonly CreateLIMSAsphaltMixDesignTarget = CreateLIMSAsphaltMixDesignTarget
  readonly EditLIMSAsphaltMixDesignTarget = EditLIMSAsphaltMixDesignTarget
  readonly RemoveRestoreLIMSAsphaltMixDesignTarget =
    RemoveRestoreLIMSAsphaltMixDesignTarget
  readonly ViewLIMSAsphaltMixDesignTarget = ViewLIMSAsphaltMixDesignTarget
  readonly CreateEngineeringJudgement = CreateEngineeringJudgement
  readonly EditEngineeringJudgement = EditEngineeringJudgement
  readonly ViewEngineeringJudgement = ViewEngineeringJudgement
  readonly RemoveRestoreEngineeringJudgement = RemoveRestoreEngineeringJudgement
  readonly RevertEngineeringJudgement = RevertEngineeringJudgement
  readonly CreateEJType = CreateEJType
  readonly ViewEJType = ViewEJType
  readonly EditEJType = EditEJType
  readonly RemoveRestoreEJType = RemoveRestoreEJType
  readonly CreateEJQuickLink = CreateEJQuickLink
  readonly ViewEJQuickLink = ViewEJQuickLink
  readonly EditEJQuickLink = EditEJQuickLink
  readonly RemoveRestoreEJQuickLink = RemoveRestoreEJQuickLink
  readonly ViewEJNotification = ViewEJNotification
  readonly EditEJNotification = EditEJNotification
  readonly SyncUsers = SyncUsers
  readonly EditRFIResponse = EditRFIResponse
  readonly RefreshRedisCache = RefreshRedisCache
  get values() {
    return [
      this.SyncUsers,
      this.AssociateProjectWithCIMS,
      this.CreateAPIKey,
      this.RemoveAPIKey,
      this.ViewAPIKey,
      this.EditRFIResponse,
      this.CreatePayItemConnection,
      this.CreatePayItemConnectionGroup,
      this.EditPayItemConnection,
      this.EditPayItemConnectionGroup,
      this.EditPayItemSummary,
      this.RemoveRestorePayItemConnection,
      this.RemoveRestorePayItemConnectionGroup,
      this.SyncPayItemConnection,
      this.ViewPayItemConnection,
      this.ViewPayItemConnectionGroup,
      this.ViewPayItemSummary,
      this.EditCASNotification,
      this.ViewCASNotification,
      this.CreateCASQuickLink,
      this.EditCASQuickLink,
      this.RemoveRestoreCASQuickLink,
      this.ViewCASQuickLink,
      this.CreateCASRoutingGroup,
      this.EditCASRoutingGroup,
      this.RemoveRestoreCASRoutingGroup,
      this.ViewCASRoutingGroup,
      this.CreateCASSubtype,
      this.EditCASSubtype,
      this.RemoveRestoreCASSubtype,
      this.ViewCASSubtype,
      this.CommentOnConstructionAdminSubmittal,
      this.CreateConstructionAdminSubmittal,
      this.CreateCASPacket,
      this.EditConstructionAdminSubmittal,
      this.EditNumberNameConstructionAdminSubmittal,
      this.GiveDispositionConstructionAdminSubmittal,
      this.GroupReviewConstructionAdminSubmittal,
      this.RemoveRestoreConstructionAdminSubmittal,
      this.RevertConstructionAdminSubmittal,
      this.ReviewAllConstructionAdminSubmittal,
      this.ReviseConstructionAdminSubmittal,
      this.RouteConstructionAdminSubmittal,
      this.UnlockConstructionAdminSubmittal,
      this.ViewConstructionAdminSubmittal,
      this.CreateCASType,
      this.ViewCASType,
      this.EditCASType,
      this.RemoveRestoreCASType,
      this.EditDesignSubmittalAction,
      this.RemoveRestoreDesignSubmittalAction,
      this.ViewDesignSubmittalAction,
      this.CreateDesignSubmittalAction,
      this.CreateDesignSubmittalDiscipline,
      this.EditDesignSubmittalDiscipline,
      this.RemoveRestoreDesignSubmittalDiscipline,
      this.ViewDesignSubmittalDiscipline,
      this.CommentOnDesignSubmittal,
      this.CreateDesignSubmittal,
      this.EditDesignSubmittal,
      this.EditNumberNameDesignSubmittal,
      this.GiveDispositionDesignSubmittal,
      this.RemoveRestoreDesignSubmittal,
      this.RevertDesignSubmittal,
      this.ReviewAllDesignSubmittal,
      this.RouteDesignSubmittal,
      this.UnlockDesignSubmittal,
      this.ViewDesignSubmittal,
      this.EditDSNotification,
      this.ViewDSNotification,
      this.CreateDesignSubmittalOrganization,
      this.EditDesignSubmittalOrganization,
      this.RemoveRestoreDesignSubmittalOrganization,
      this.ViewDesignSubmittalOrganization,
      this.CreateDesignSubmittalQuickLink,
      this.EditDesignSubmittalQuickLink,
      this.RemoveRestoreDesignSubmittalQuickLink,
      this.ViewDesignSubmittalQuickLink,
      this.CreateDesignSubmittalType,
      this.EditDesignSubmittalType,
      this.RemoveRestoreDesignSubmittalType,
      this.ViewDesignSubmittalType,
      this.ImportCSV,
      this.ExportCSV,
      this.CreateBatchReportRequest,
      this.EditPDFDesignLayer,
      this.ViewPDFDesignLayer,
      this.EditFilename,
      this.ViewFilename,
      this.CreatePhotoExportRequest,
      this.CreateReport,
      this.CreateConcretePacket,
      this.EditAssociatedDocumentChecklistItem,
      this.EditConcreteBreakData,
      this.RemoveConcretePacketFile,
      this.UploadConcretePacketFile,
      this.ViewConcretePacketFile,
      this.ViewConcreteTestSet,
      this.CreateDocumentChecklistItem,
      this.EditDocumentChecklistItem,
      this.RemoveDocumentChecklistItem,
      this.ViewDocumentChecklistItem,
      this.EditConcreteNotification,
      this.ViewConcreteNotification,
      this.CreateLabTech,
      this.CreateTestingLab,
      this.EditAllTestingLab,
      this.EditLabTech,
      this.EditLimitedTestingLab,
      this.RemoveLabTech,
      this.RemoveTestingLab,
      this.ViewLabTech,
      this.ViewTestingLab,
      this.CreateFDCApprovalGroup,
      this.EditFDCApprovalGroup,
      this.RemoveRestoreFDCApprovalGroup,
      this.ViewFDCApprovalGroup,
      this.CreateFDCConcurrenceGroup,
      this.CreateFDCConcurrenceLevel,
      this.EditFDCConcurrenceGroup,
      this.EditFDCConcurrenceLevel,
      this.RemoveRestoreFDCConcurrenceGroup,
      this.RemoveRestoreFDCConcurrenceLevel,
      this.ViewFDCConcurrenceGroup,
      this.ViewFDCConcurrenceLevel,
      this.CreateFDCDiscipline,
      this.EditFDCDiscipline,
      this.RemoveRestoreFDCDiscipline,
      this.ViewFDCDiscipline,
      this.EditFDCNotification,
      this.ViewFDCNotification,
      this.CreateFDCQuickLink,
      this.EditFDCQuickLink,
      this.RemoveRestoreFDCQuickLink,
      this.ViewFDCQuickLink,
      this.CommentOnFieldDesignChange,
      this.CreateFieldDesignChange,
      this.EditFieldDesignChange,
      this.EditFieldDesignChangeResolution,
      this.RevertFieldDesignChange,
      this.RemoveRestoreFieldDesignChange,
      this.UnlockFieldDesignChange,
      this.ViewFieldDesignChange,
      this.CreateCustomField,
      this.EditCustomField,
      this.RemoveRestoreCustomField,
      this.ViewCustomField,
      this.CreateNonUserEmail,
      this.EditNonUserEmail,
      this.RemoveNonUserEmail,
      this.ViewNonUserEmail,
      this.CreateRole,
      this.EditRole,
      this.RemoveRestoreRole,
      this.ViewRole,
      this.EditProjectSettings,
      this.EditSharePointSettings,
      this.EditWorkflowSettings,
      this.ViewProjectSettings,
      this.EditUserPermission,
      this.EditUserRole,
      this.ViewUser,
      this.ViewIdentifiedFieldIssue,
      this.EditIdentifiedFieldIssue,
      this.ReviewIdentifiedFieldIssue,
      this.RevertIdentifiedFieldIssue,
      this.CommentOnIdentifiedFieldIssue,
      this.EditIFINotification,
      this.ViewIFINotification,
      this.CreateIssueType,
      this.EditIssueType,
      this.RemoveRestoreIssueType,
      this.ViewIssueType,
      this.CreateIssue,
      this.EditIssue,
      this.RemoveRestoreIssue,
      this.ViewIssue,
      this.EditIssueResponse,
      this.CommentOnIssue,
      this.RevertIssue,
      this.UnlockIssue,
      this.RespondToIssue,
      this.GiveIssueDisposition,
      this.CloseIssue,
      this.CreateIssueQuickLink,
      this.EditIssueQuickLink,
      this.RemoveRestoreIssueQuickLink,
      this.ViewIssueQuickLink,
      this.EditIssueNotification,
      this.ViewIssueNotification,
      this.CreateIssueDispositionType,
      this.EditIssueDispositionType,
      this.RemoveRestoreIssueDispositionType,
      this.ViewIssueDispositionType,
      this.CreateRequestForInformation,
      this.ViewRequestForInformation,
      this.EditRequestForInformation,
      this.RemoveRestoreRequestForInformation,
      this.CommentOnRequestForInformation,
      this.RespondAllRFIResponseDisciplines,
      this.RevertRequestForInformation,
      this.UnlockRequestForInformation,
      this.CreateRFIOrganization,
      this.ViewRFIOrganization,
      this.EditRFIOrganization,
      this.RemoveRestoreRFIOrganization,
      this.CreateRFIResponseDiscipline,
      this.ViewRFIResponseDiscipline,
      this.EditRFIResponseDiscipline,
      this.RemoveRestoreRFIResponseDiscipline,
      this.CreateRFIQuickLink,
      this.ViewRFIQuickLink,
      this.EditRFIQuickLink,
      this.RemoveRestoreRFIQuickLink,
      this.ViewRFINotification,
      this.EditRFINotification,
      this.CreateCASDispositionType,
      this.EditCASDispositionType,
      this.RemoveRestoreCASDispositionType,
      this.ViewCASDispositionType,
      this.CreateAsphaltMixDesign,
      this.EditAsphaltMixDesign,
      this.ViewAsphaltMixDesign,
      this.CreateConcreteMixDesign,
      this.EditConcreteMixDesign,
      this.ViewConcreteMixDesign,
      this.CreateLIMSAsphaltMixDesignTarget,
      this.EditLIMSAsphaltMixDesignTarget,
      this.RemoveRestoreLIMSAsphaltMixDesignTarget,
      this.ViewLIMSAsphaltMixDesignTarget,
      this.CreateEngineeringJudgement,
      this.EditEngineeringJudgement,
      this.ViewEngineeringJudgement,
      this.RemoveRestoreEngineeringJudgement,
      this.RevertEngineeringJudgement,
      this.CreateEJType,
      this.ViewEJType,
      this.EditEJType,
      this.RemoveRestoreEJType,
      this.CreateEJQuickLink,
      this.ViewEJQuickLink,
      this.EditEJQuickLink,
      this.RemoveRestoreEJQuickLink,
      this.ViewEJNotification,
      this.EditEJNotification,
      this.RefreshRedisCache,
    ]
  }
}

export const Permission = new PermissionEnum()
